import { render } from "./AlzataTab.vue?vue&type=template&id=3aa16ece"
import script from "./AlzataTab.vue?vue&type=script&lang=js"
export * from "./AlzataTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__